"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EmployeesPositionsChartCard;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Theme_1 = require("../Theme");
const ThemeContext_1 = require("../ThemeContext");
const UserContext_1 = require("../contexts/UserContext");
const Card_1 = __importDefault(require("../components/Card"));
const CardTitle_1 = __importDefault(require("../components/CardTitle"));
const react_i18next_1 = require("react-i18next");
const cancelable_promise_1 = require("cancelable-promise");
const Employees_1 = __importDefault(require("../api/Employees"));
const Loading_1 = __importDefault(require("../components/Loading"));
const GiftedCharts_1 = __importDefault(require("../shared/GiftedCharts"));
const Helper_1 = require("../Helper");
const TableHeader_1 = __importDefault(require("../components/TableHeader"));
const ChartLegendItem_1 = __importStar(require("./ChartLegendItem"));
const ActionMenuButton_1 = __importDefault(require("../components/ActionMenuButton"));
const FirebaseAnalytics_1 = __importDefault(require("../shared/FirebaseAnalytics"));
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
function EmployeesPositionsChartCard(props) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const THEME = (0, ThemeContext_1.useTheme)();
    const ChartColors = (0, Theme_1.useChartColors)();
    const PieChart = GiftedCharts_1.default.PieChart;
    const userContext = react_1.default.useContext(UserContext_1.UserContext);
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    const promise = react_1.default.useRef(null);
    const [status, setStatus] = react_1.default.useState('loading');
    const [positionPieData] = react_1.default.useState([]);
    const [consolidatedPosData, setConsolidatedPosData] = react_1.default.useState([]);
    const [otherPositions, setOtherPositions] = react_1.default.useState([]);
    const refresh = react_1.default.useCallback(() => {
        promise.current?.cancel();
        setStatus('loading');
        promise.current = (0, cancelable_promise_1.cancelable)(userContext.getToken().then((token) => {
            Employees_1.default.getEmployeePositions(token).then((r) => {
                let colorIndex = 0;
                let overflow = { text: t('myBenefits:text.other'), value: 0, color: ChartColors[10] };
                let useOverflow = false;
                r.sort((a, b) => (a?.eeCount > b?.eeCount ? -1 : 1));
                r.forEach(job => {
                    if (job.eeCount > 0) {
                        // If we exceed ten positions, consolidate the rest into "other"
                        if (colorIndex > 9) {
                            overflow.value += job.eeCount;
                            useOverflow = true;
                            otherPositions.push({
                                text: job.name,
                                code: job.code,
                                value: job.eeCount
                            });
                        }
                        else {
                            positionPieData.push({
                                value: job.eeCount,
                                text: Helper_1.Helper.FormatTitleCase(job.name),
                                color: ChartColors[colorIndex]
                            });
                            consolidatedPosData.push(job);
                            ++colorIndex;
                        }
                    }
                });
                consolidatedPosData.sort((a, b) => (a?.eeCount > b?.eeCount ? -1 : 1));
                if (useOverflow) {
                    positionPieData.push(overflow);
                    consolidatedPosData.push({ name: t('myBenefits:text.other'), eeCount: overflow.value });
                }
                setStatus('done');
            });
        }).catch(() => {
            setStatus('error');
        }));
    }, []);
    react_1.default.useEffect(() => {
        refresh();
        return () => {
            promise.current?.cancel();
        };
    }, []);
    return ((0, jsx_runtime_1.jsxs)(Card_1.default, { children: [(0, jsx_runtime_1.jsx)(CardTitle_1.default, { title: t('employees:text.employeesByPos'), style: { marginBottom: 8 }, children: (0, jsx_runtime_1.jsx)(ActionMenuButton_1.default, { actionsList: [
                        { label: t('employees:labels.addNew'),
                            ariaLabel: t('employees:hints.positionAdd'),
                            icon: Theme_1.ICONS.Regular.Plus,
                            onPress: () => {
                                FirebaseAnalytics_1.default.LogEvent('feature_used', {
                                    'feature': "Add Position",
                                    'client': userContext.client?.id,
                                    'employee': userContext.employee?.employeeId
                                });
                                props.navigation.navigate('AddPosition', { mode: 'new' });
                            }
                        },
                        { label: t('employees:labels.addFrom'),
                            ariaLabel: t('employees:hints.positionCopy'),
                            icon: Theme_1.ICONS.Regular.Copy,
                            onPress: () => {
                                FirebaseAnalytics_1.default.LogEvent('feature_used', {
                                    'feature': "Add Position (Existing)",
                                    'client': userContext.client?.id,
                                    'employee': userContext.employee?.employeeId
                                });
                                props.navigation.navigate('AddPosition', { mode: 'copy' });
                            }
                        }
                    ], label: t('common:buttons.add'), buttonType: 'outline', menuItemTextStyle: { marginTop: size != 'sm' ? 0 : 4 } }) }), (status == 'done' && ((0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                    margin: 12,
                    alignItems: 'center',
                }, children: [(0, jsx_runtime_1.jsx)(PieChart, { data: positionPieData, donut: true, innerRadius: size != 'sm' ? 65 : 56, radius: size != 'sm' ? 105 : 90, innerCircleColor: THEME.CardBackground }), (0, jsx_runtime_1.jsxs)(react_native_1.View, { style: {
                            flex: 1,
                            width: '100%',
                            marginTop: 18
                        }, children: [(0, jsx_runtime_1.jsx)(TableHeader_1.default, { style: { marginBottom: 6, width: '100%' }, columns: [
                                    { flex: 2, label: t('employees:labels.position'), align: 'flex-start', indent: 30 },
                                    { flex: 1, label: t('employees:text.employees'), align: 'center', indent: 4 },
                                    { flex: 1, label: '', align: 'flex-end' }
                                ] }), consolidatedPosData.map((item, index) => (item.eeCount != 0 && (item.name == t('myBenefits:text.other') ?
                                (0, jsx_runtime_1.jsx)(ChartLegendItem_1.ExpandableChartLegendItem, { ariaLabel: t('employees:hints.positionDetails'), item: { text: item.name, value: item.eeCount, color: positionPieData[index].color }, expansionItems: otherPositions, onPress: (subItem) => props.navigation.navigate('PositionDetails', { code: subItem.code }) }, index)
                                :
                                    (0, jsx_runtime_1.jsx)(ChartLegendItem_1.default, { ariaLabel: t('employees:hints.positionDetails'), item: { text: item.name, value: item.eeCount, color: positionPieData[index].color }, onPress: () => props.navigation.navigate('PositionDetails', { code: item.code }), pressable: true }, index))))] })] }))) || (0, jsx_runtime_1.jsx)(Loading_1.default, { retryable: true, loading: status == 'loading', error: status == 'error', onRetry: () => refresh() })] }));
}
;
